module.exports = __webpack_public_path__ + "img/取消.d2dc6b5a.svg";